module.exports = __webpack_public_path__ + "posture/static/img/spine_sideway_right.448871d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/spine_sideway_right.png
// module id = y73U
// module chunks = 1